import * as tslib_1 from "tslib";
import { css } from 'styled-components';
var BorderButtonStyle = css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  border: 1px solid currentColor;\n  border-radius: 2px;\n"], ["\n  border: 1px solid currentColor;\n  border-radius: 2px;\n"])));
export default BorderButtonStyle;
var templateObject_1;
//# sourceMappingURL=BorderButtonStyle.js.map